import {
  type SelectionsActions,
  type SelectionIntent,
  type SelectedValueCoordinate,
  type SelectionMutationOptions
} from '@databases/selections-api-types';

import { type SelectionsApi } from '../../selections-api.ts';

export interface SelectionsApiAdapterOptions {
  selectionsApi: SelectionsApi;
}

/** Exposes the stable SelectionsActions contract through the authoritative API. */
export class SelectionsApiAdapter implements SelectionsActions {
  #api: SelectionsApi;

  constructor(options: SelectionsApiAdapterOptions) {
    this.#api = options.selectionsApi;
  }

  selectFields(fieldIds: string[], _options: SelectionMutationOptions = {}): void {
    this.#api.selectFields(fieldIds);
  }

  selectEntries(entryIds: string[], _options: SelectionMutationOptions = {}): void {
    this.#api.selectEntries(entryIds);
  }

  selectValues(
    values: SelectedValueCoordinate[],
    _options: SelectionMutationOptions = {}
  ): void {
    this.#api.selectValues(values);
  }

  deselectAll(): void {
    this.#api.deselectAll();
  }

  setSelectionIntent(_intent: SelectionIntent): void {
    this.#api.previewDeleteIntent();
  }

  clearSelectionIntent(): void {
    this.#api.clearPreviewIntent();
  }
}
